/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuntimeRoundListRequest
 */
export interface RuntimeRoundListRequest {
    /**
     * 
     * @type {string}
     * @memberof RuntimeRoundListRequest
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof RuntimeRoundListRequest
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof RuntimeRoundListRequest
     */
    size: number;
}

export function RuntimeRoundListRequestFromJSON(json: any): RuntimeRoundListRequest {
    return RuntimeRoundListRequestFromJSONTyped(json, false);
}

export function RuntimeRoundListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeRoundListRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'page': json['page'],
        'size': json['size'],
    };
}

export function RuntimeRoundListRequestToJSON(value?: RuntimeRoundListRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'page': value.page,
        'size': value.size,
    };
}


